<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="return()">Back<ion-icon slot="start" name="chevron-back-outline"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title>Payment Processing</ion-title>
  </ion-toolbar>
</red-header-content>

<red-page-content>
  <ion-card>
    <ion-card-header>
      <ion-card-title>
        <div class="tw:flex tw:justify-items-center">
          @if (isSuccess) {
          <ion-icon name="checkmark-circle-outline" color="success" size="large"></ion-icon>
          <ion-text color="success">Success</ion-text>
          } @else {
          <ion-icon name="close-circle-outline" color="danger" size="large"></ion-icon>
          <ion-text color="danger">Failure</ion-text>
          }
        </div>
      </ion-card-title>
    </ion-card-header>

    <ion-card-content>
      @if (isSuccess) { Your payment was processed with success.<br /><br />
      <span class="tw:italic"> *It might take a few minutes for our systems to process your purchase. </span>
      } @else { There was a issue processing your payment. }
    </ion-card-content>
  </ion-card>
  @if (timeRemaining$) {
  <div class="tw:m-4 tw:text-center tw:text-xs">
    <ion-note color="medium">You will be redirected back in {{timeRemaining$ | async | date:'ss'}} seconds.</ion-note>
  </div>
  }
</red-page-content>
